<template>
    <el-tabs v-model="activeName" type="card" class="cls-tabs-content">
        <el-tab-pane label="联行号基础库" name="cnaps"><Cnaps></Cnaps></el-tab-pane>
        <el-tab-pane label="银盛银行代码" name="ysfbank"><YsfBank></YsfBank></el-tab-pane>
    </el-tabs>
</template>

<script>
    import YsfBank from '../../components/sys/paybank/YsfBank'
    import Cnaps from '../../components/sys/paybank/Cnaps'
    export default {
        name: "SysCfg",
        data() {
            return{
                activeName: 'cnaps'
            }
        },
        components:{
            YsfBank,
            Cnaps,
        }
    }
</script>

<style lang="less"  scoped>
    .cls-tabs-content {
        :deep(.el-tabs__content) {
            height:100%;
            display: flex;
            flex-flow:column;
        }
        :deep(.el-tab-pane) {
            height: calc(100% - 30px - 20px);
        }
        :deep(.el-tabs__item) {
            height: 30px;
            line-height: 30px;
            font-size: 12px;
            color: #616161;
        }
        :deep(.el-tabs__item.is-active) {
            color: deepskyblue;
            background-color: #F5F5F5;
            border-bottom-color: #F5F5F5;
        }
    }
</style>
